/**
 * Platform admin card: static notes on how the Users tab reports usage.
 */
import React from 'react';
import { View } from 'react-native';
import { Text } from '@/components/ui/text';
import { AdminSectionCard, AdminStatusPill, ADMIN_COLORS } from '@/components/admin/AdminUI';

export default function UsageReportingCard() {
  return (
    <AdminSectionCard
      icon="query-stats"
      title="Usage Reporting"
      subtitle="The Users tab reads usage from UsageEvent rows in each account's current billing period."
    >
      <View className="flex-row flex-wrap" style={{ gap: 8 }}>
        <AdminStatusPill label="B2C: individual limits" tone="success" />
        <AdminStatusPill label="Schools: shared credit pool" tone="warning" />
        <AdminStatusPill label="Period: billing cycle" tone="primary" />
      </View>
      <Text className="text-sm" style={{ color: ADMIN_COLORS.text.secondary }}>
        Transcript analyses, transcription minutes, and chat requests are counted from UsageEvent records.
        School rows show each member&apos;s activity, but billing consumption belongs to the school&apos;s shared pool.
      </Text>
    </AdminSectionCard>
  );
}
